import { create } from 'zustand';
import type { BookingDto, RoomDb } from '../api/rooms.js';

/**
 * HM-080 — Check-out modal state.
 *
 * Modal singolo (no wizard come walk-in): mostra summary booking + costi
 * + button "Conferma check-out". Il backend POST /bookings/:id/checkout
 * (ONDATA 1: il legacy /check-out e' 410 Gone) incassa il saldo (base +
 * ore extra + room-service a voucher) PRIMA di marcare checked_out, poi
 * gestisce scontrino, revoca codici, clima OFF.
 */
export type CheckoutState = {
  isOpen: boolean;
  room: RoomDb | null;
  booking: BookingDto | null;
  open: (room: RoomDb, booking: BookingDto) => void;
  close: () => void;
};

export const useCheckoutModal = create<CheckoutState>((set) => ({
  isOpen: false,
  room: null,
  booking: null,
  open: (room, booking) => set({ isOpen: true, room, booking }),
  close: () => set({ isOpen: false, room: null, booking: null }),
}));
